import { render, staticRenderFns } from "./edit_button.vue?vue&type=template&id=1b03cb38&"
import script from "./edit_button.vue?vue&type=script&lang=js&"
export * from "./edit_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b03cb38')) {
      api.createRecord('1b03cb38', component.options)
    } else {
      api.reload('1b03cb38', component.options)
    }
    module.hot.accept("./edit_button.vue?vue&type=template&id=1b03cb38&", function () {
      api.rerender('1b03cb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/edit_button.vue"
export default component.exports